import "./wizard.less";

import {t} from "@lingui/core/macro";
import * as React from "react";

import Button from "@khanacademy/wonder-blocks-button";
import {useOnMountEffect} from "@khanacademy/wonder-blocks-core";
import {usePublishAnalyticsEvent} from "@khan/analytics-learning-time";

import {TEACHER_KHANMIGO_TOOLS_PATH} from "#coach-dashboard-package/khanmigo/path-helpers.ts";

export default function AlreadyEnrolledFreeForTeachers(): React.ReactElement {
    const publishAnalyticsEvent = usePublishAnalyticsEvent();
    useOnMountEffect(() => {
        publishAnalyticsEvent({
            eventType: "AiGuideTeacherFeaturesEnrolledPageViewed",
            eventSchemaVersion: 1,
        });
    });

    return (
        <div className="wizard-view">
            <div className="container">
                <h1 className="already-have-khanmigo">
                    {t`Hmm... It looks like you already have access to Khanmigo.`}
                </h1>
                <p>{t`Thank you for your interest in Khanmigo`}</p>
                <div className="action">
                    <Button href={TEACHER_KHANMIGO_TOOLS_PATH}>
                        {t`Start using Khanmigo`}
                    </Button>
                </div>
            </div>
        </div>
    );
}
